import React, { Component } from 'react';
import { css } from 'emotion';

import DiscoAdsIntentSearchBar from './DiscoAdsIntentSearchBar';
import DiscoAdsIntentList from './DiscoAdsIntentList';

import Colors from '../../../../../../styles/Colors';

import {
  DA_CREATOR_TOOLTIP_COPY,
  INTENT_SEARCH_RESULTS,
  SELECTED_INTENTS
} from '../../discoAdsConstants';

const staticStyles = {
  selectedIntentsHeader: css({
    height: '60px',
    display: 'flex',
    paddingLeft: '20px',
    alignItems: 'center',
    fontSize: '16px',
    color: Colors['@ash-gray'],
    backgroundColor: Colors['@white-lilac']
  })
};

class DiscoAdsIntentListWrapper extends Component {
  render() {
    const {
      intentsModal: {
        popularity: popularityTooltipCopy,
        maxCpc: maxCpcTooltipCopy
      }
    } = DA_CREATOR_TOOLTIP_COPY;
    const dynamicStyles = {
      intentsContainer: css({
        height: '460px',
        minWidth: '340px',
        backgroundColor: `${
          this.props.type === INTENT_SEARCH_RESULTS
            ? Colors['@white-lilac']
            : Colors['@white']
        }`,
        boxSizing: 'border-box',
        border: `1px solid ${Colors['@athens-gray']}`,
        borderRadius: '2px',
        margin: '10px',
        overflow: 'hidden'
      })
    };
    const { intentsContainer, selectedIntentsHeader } = Object.assign(
      {},
      dynamicStyles,
      staticStyles
    );
    const {
      type,
      data,
      onIntentClick,
      onIntentBidChange,
      userQuery,
      onSearchBarQueryChange,
      pageIsLoading
    } = this.props;
    return (
      <div className={intentsContainer}>
        {type === INTENT_SEARCH_RESULTS && (
          <div>
            <DiscoAdsIntentSearchBar
              userQuery={userQuery}
              onChange={onSearchBarQueryChange}
            />
            <DiscoAdsIntentList
              data={data}
              type={type}
              tooltipBody={popularityTooltipCopy}
              onIntentClick={onIntentClick}
              pageIsLoading={pageIsLoading}
            />
          </div>
        )}
        {type === SELECTED_INTENTS && (
          <div>
            <div className={selectedIntentsHeader}>Selected Intents</div>
            <DiscoAdsIntentList
              data={data}
              type={type}
              tooltipBody={maxCpcTooltipCopy}
              onIntentClick={onIntentClick}
              onIntentBidChange={onIntentBidChange}
            />
          </div>
        )}
      </div>
    );
  }
}

export default DiscoAdsIntentListWrapper;
